import styled from 'styled-components'

interface ContainerProps {
  bg?: string;
}

export const Container = styled.div<ContainerProps>`
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ bg }) =>
    bg
      ? `linear-gradient(180deg, ${bg} 0%, rgba(196, 196, 196, 0) 100%)`
      : 'linear-gradient(180deg, #7B61FF 0%, rgba(196, 196, 196, 0) 100%)'
  };
`

interface ImageSize {
  width?: string;
  height?: string;
}

interface ImageProps {
  $imgSize?: ImageSize;
}

export const Image = styled.img<ImageProps>`
  width: ${({ $imgSize }) => $imgSize?.width || '105px'};
  height: ${({ $imgSize }) => $imgSize?.height || '105px'};
  object-fit: cover;
  border-radius: 50%;
`
